module.exports = __webpack_public_path__ + "static/media/robin.1051d38b.jpg";